import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="select-filter"
export default class extends Controller {
  static targets = [
    "query",
    "list",
    "language",
    "assessment",
    "category",
    "assessment_type",
  ]

  apply_filter() {
    const frame = this.listTarget
    const searchQuery = this.queryTarget
    const selectedAssessmentType = this.hasAssessmentTarget
      ? this.assessmentTarget.value
      : "assessment_definitions"

    let endpoint = new URL(window.location.href)
    endpoint.searchParams.set("query", searchQuery.value)
    endpoint.searchParams.set("step", "assignment")
    endpoint.searchParams.set("filter", selectedAssessmentType)
    if (this.hasCategoryTarget) {
      endpoint.searchParams.set("category", this.categoryTarget.value)
    }
    if (this.hasAssessment_typeTarget) {
      endpoint.searchParams.set(
        "assessment_type",
        this.assessment_typeTarget.value,
      )
    }
    endpoint.searchParams.set(
      "language",
      this.languageTarget.options[this.languageTarget.selectedIndex].value,
    )

    frame.src = endpoint.toString()
  }
}
